import { MenuProps, Menu as AntdMenu } from 'antd'
import styled from 'styled-components'

const ICCON_FONT_SIZE = 20

const StyledMenu = styled(AntdMenu)`
  span > svg {
    font-size: ${ICCON_FONT_SIZE}px;
  }
` as typeof AntdMenu

const Menu = (props: MenuProps) => <StyledMenu {...props} />

export default Menu
